module.exports = "/_next/static/images/pizza_ioro-f9128a4ed7954fd6637b8944310297ad.jpg";